var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomSelectClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13L17 20L20 17L13 10L20 3L17 0L10 7L3 0L0 3L7 10L0 17L3 20L10 13Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSelectClose);
export default __webpack_public_path__ + "static/media/CustomSelectClose.183167aa816d6de6f5a8945b8d9cea01.svg";
export { ForwardRef as ReactComponent };